module.exports = __webpack_public_path__ + "img/download.2ba2dad7.png";